import React, {
  createContext,
  useContext,
  useState,
} from "react";
import { IChapter, IDraftChapter } from "models/wall";
import { createDraftFromChapterApi } from "api/chapters";
import { getDraftChaptersById } from "api/draftChapters";
import { useWallDataContext } from "./WallContext";


type ChapterDisplayContextType = {
  chapter: IChapter;
  isCollapsed: boolean;
  setIsCollapsed: React.Dispatch<React.SetStateAction<boolean>>;
  isEditorOpen: boolean;
  setIsEditorOpen: React.Dispatch<React.SetStateAction<boolean>>;
  openEditor: () => void;
  initialDraft: IDraftChapter | undefined;
};

const ChapterDisplayDataContext = createContext<ChapterDisplayContextType | undefined>(
  undefined
);

export const ChapterDisplayDataProvider = ({children, chapter}: {
  children: React.ReactNode;
  chapter: IChapter;
}) => {
  const {updateDraftUuid} = useWallDataContext();
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const [initialDraft, setInitialDraft] = useState<IDraftChapter>();

  const openEditor = async () => {
    if (!chapter.uuid) return;

    if (!chapter.draft_uuid) {
      const res = await createDraftFromChapterApi(chapter.uuid);
      updateDraftUuid(chapter.uuid, res.uuid ?? null);
      setInitialDraft(res);
    } else {
      const res = await getDraftChaptersById(chapter.draft_uuid);
      setInitialDraft(res);
    }

    setIsEditorOpen(true);
  };

  return (
    <ChapterDisplayDataContext.Provider value={{
      chapter,
      isCollapsed,
      setIsCollapsed,
      isEditorOpen,
      setIsEditorOpen,
      openEditor,
      initialDraft
    }}>
      {children}
    </ChapterDisplayDataContext.Provider>
  );
};

export const useChapterDisplayDataContext = () => {
  const context = useContext(ChapterDisplayDataContext);
  if (!context) {
    throw new Error("useChapterDisplayDataContext must be used within a ChapterDisplayDataProvider");
  }
  return context;
};
